import '../styles/App.css';

function Footer() {
    return (
        <>
            <footer>
                Website footer, has a couple of links throughout the site.
            </footer>
        </>
    )
}

export default Footer;